import React from "react";
import "./NoResultsComponent.scss";
import { useTranslation } from "react-i18next";

const NoResults: React.FC = (props: any) => {
  const { t } = useTranslation("home");
  return (
    <div className="no-results-div">
      <div className="input-icon icon-no_result icon-no_result-div"></div>
      <div className="no-results-message"> {t("noResultsFound")}</div>
    </div>
  );
};

export default NoResults;
